import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

import Form from 'UI/molecules/Form';

const FirstSurnameField = forwardRef((props, ref) => {
  const { t } = useTranslation('userDataCard');

  const { errors, ...other } = props;

  return (
    <Form.Field>
      <Form.Label htmlFor="form_surname1">
        {t('form.step2.surname1.label')} *
      </Form.Label>
      <Form.Control>
        <Form.Input
          error={errors.surname1}
          id="form_surname1"
          name="surname1"
          ref={ref}
          {...other}
          placeholder={t('form.step2.surname1.placeholder')}
        />
        {errors.surname1 && <Form.Error>{errors.surname1?.message}</Form.Error>}
      </Form.Control>
    </Form.Field>
  );
});

FirstSurnameField.displayName = 'FirstSurnameField';

FirstSurnameField.propTypes = {
  errors: PropTypes.object,
};

export default FirstSurnameField;
